const translations = {
  english: {
    english: 'ENGLISH',
    korean: '영어',
    spanish: 'INGLÉS',
    chinese : '英语'
  },
  languages: {
    english: 'ENGLISH',
    korean: '한글',
    spanish: 'ESPAÑOL',
    chinese: '中文'
  },
  language: {
    english: 'LANGUAGE',
    korean: '언어',
    spanish: 'IDIOMA',
    chinese: '语言'
  },
  homeTitle: {
    line1: {
      english: 'YUT',
      korean: '우주',
      chinese: '擲'
    },
    line2: {
      english: 'NORI',
      korean: '윷놀이',
      chinese: '戲'
    }
  },
  howToPlay: {
    english: 'How To Play',
    korean: '설명서'
  },
  hostAGame: {
    english: 'Host a game',
    korean: '게임 만들기'
  },
  joinAGame: {
    english: 'Join a game',
    korean: '게임 참여'
  },
  joinGameModal: {
    title: {
      english: 'Enter the Room ID',
      korean: '방 ID를 입력하세요',
      spanish: 'Ingresa el ID de sala',
      chinese: '输入房间编号'
    },
    placeholder: {
      english: 'here...',
      korean: '여기에...',
      spanish: 'aquí...',
      chinese: '在这里输入……'
    },
    submit: {
      english: 'LETS GO!',
      korean: '출발!',
      spanish: 'VAMOS!',
      chinese: '开始！'
    },
    cancel: {
      english: 'CANCEL',
      korean: '취소',
      spanish: 'CANCELAR',
      chinese: '取消'
    },
    errorNotExists: {
      english: "Room with that ID doesn't exist",
      korean: '해당 ID의 방이 존재하지 않습니다',
      spanish: 'No existe una sala con ese ID',
      chinese: '该房间编号不存在'
    },
    errorAlphaNumeric: {
      english: 'ID can only contain letters and numbers',
      korean: 'ID는 문자와 숫자만 포함할 수 있습니다',
      spanish: 'El ID solo puede tener letras y números',
      chinese: '编号只能包含字母和数字'
    }
  },
  minigames: {
    timeAlert: {
      english: 'MINIGAME!',
      korean: '미니게임!',
      spanish: '¡MINIJUEGO!',
      chinese: '小游戏！'
    },
    bubbleMatch: {
      title: { english: 'BUBBLE MATCH', korean: '버블 매치', spanish: 'BURBUJAS', chinese: '泡泡匹配' },
      rule: { english: 'MATCH 3 OR MORE BUBBLES.', korean: '버블 3개 이상을 맞추세요.', spanish: 'UNE 3 O MÁS BURBUJAS.', chinese: '匹配3个或更多泡泡。' }
    },
    starFall: {
      title: { english: 'STAR FALL', korean: '별 피하기', spanish: 'LLUVIA DE ESTRELLAS', chinese: '星星下落' },
      rule: { english: 'MOVE YOUR SHIP TO AVOID THE FALLING STARS', korean: '배를 움직여 떨어지는 별을 피하세요.', spanish: 'MUEVE TU NAVE Y EVITA LAS ESTRELLAS.', chinese: '移动飞船，避开坠落的星星。' }
    },
    twentyFingers: {
      title: { english: 'STAR COLLECTOR', korean: '별 수집가', spanish: 'COLECTOR DE ESTRELLAS', chinese: '星星收集者' },
      rule: { english: 'COLLECT MORE STARS THAN THE OTHER TEAM', korean: '상대 팀보다 별을 더 많이 모으세요.', spanish: 'RECOGE MÁS ESTRELLAS QUE EL OTRO EQUIPO.', chinese: '比对方队伍收集更多星星。' }
    },
    hideAndSeek: {
      title: { english: 'HIDE AND SEEK', korean: '숨바꼭질', spanish: 'LAS ESCONDIDAS', chinese: '捉迷藏' },
      hider: { english: 'YOU ARE A HIDER', korean: '당신은 숨는 팀입니다', spanish: 'ERES QUIEN SE ESCONDE', chinese: '你是躲藏者' },
      caught: { english: 'YOU WERE CAUGHT!', korean: '잡혔습니다!', spanish: '¡TE HAN ENCONTRADO!', chinese: '你被抓到了！' },
      seeker: { english: 'YOU ARE A SEEKER', korean: '당신은 술래 입니다', spanish: 'ERES QUIEN BUSCA', chinese: '你是寻找者' },
      spectator: { english: 'SPECTATOR', korean: '관전자', spanish: 'ESPECTADOR', chinese: '观战者' },
      stayOnStar: { english: 'STAY ON TOP OF A STAR!', korean: '별 뒤로 숨으세요!', spanish: '¡QUÉDATE SOBRE UNA ESTRELLA!', chinese: '待在星星上躲藏！' },
      clickStars: { english: 'CLICK THE STARS TO FIND THEM', korean: '별을 클릭해 상대를 찾으세요', spanish: '¡HAZ CLIC EN LAS ESTRELLAS PARA ENCONTRARLES!', chinese: '点击星星找到他们' },
      foundAll: { english: 'FOUND THEM ALL!', korean: '모두 찾았습니다!', spanish: '¡LES HAS ENCONTRADO A TODOS!', chinese: '找到所有人了！' },
      survived: { english: 'SURVIVED!', korean: '살아남았습니다!', spanish: '¡HAS SOBREVIVIDO!', chinese: '幸存了！' },
      tookSeconds: { english: 'TOOK THEM {seconds} SECONDS', korean: '{seconds}초가 걸렸습니다', spanish: 'HAS TARDADO {seconds} SEGUNDOS', chinese: '用了{seconds}秒' }
    },
    actions: {
      start: { english: 'START', korean: '시작', spanish: 'INICIAR', chinese: '开始' },
      back: { english: 'BACK', korean: '뒤로', spanish: 'ATRÁS', chinese: '返回' },
      continue: { english: 'CONTINUE', korean: '계속', spanish: 'SEGUIR', chinese: '继续' }
    },
    labels: {
      rockets: { english: 'ROCKETS', korean: '로켓', spanish: 'COHETES', chinese: '火箭' },
      ufos: { english: 'UFOS', korean: 'UFO', spanish: 'OVNIS', chinese: '飞碟' },
      total: { english: 'TOTAL', korean: '합계', spanish: 'TOTAL', chinese: '总分' },
      demo: { english: 'DEMO', korean: '데모', spanish: 'DEMO', chinese: '演示' },
      howToPlay: { english: 'HOW TO PLAY', korean: '게임 방법', spanish: 'CÓMO JUGAR', chinese: '玩法说明' },
      freeYut: { english: 'FREE YUT!', korean: '보너스 윷!', spanish: '¡YUT GRATIS!', chinese: '免费擲木！' },
      timeUp: { english: 'TIME UP!', korean: '시간 초과!', spanish: '¡TIEMPO AGOTADO!', chinese: '时间到！' },
      survived: { english: 'SURVIVED', korean: '생존', spanish: 'SOBREVIVIÓ', chinese: '生存' },
      wins: { english: 'WINS!', korean: '승리!', spanish: '¡GANA!', chinese: '获胜！' }
    }
  },
  showroom: {
    english: 'SHOWROOM',
    korean: '쇼룸'
  },
  about: {
    english: 'ABOUT',
    korean: '정보'
  },
  update: {
    english: "NEW!",
    korean: '업데이트'
  },
  updateContent: {
    english: 'MOBILE CONTROLS ARE ENHANCED!\nDIRECT THE SHIPS WITH BUTTONS CLOSER\nTO YOUR THUMB.\n\nKOREAN CHARACTERS CAN NOW BE\nPROPERLY TYPED IN THE CHATBOX.\n\nTHANK YOU TO *LEO* AND *SLUGGYDOODLE*\nFOR REPORTING THIS ISSUE ON DISCORD!',
    korean: '스마트폰 터치 버튼이 더 커졌어요!\n말을 움직이는 버튼을 엄지 손가락 쪽으로 옮겼어요.\n\n이제 채팅창에서 한글을 제대로 입력할 수 있어요.\n\n이 문제를 디스코드에서 알려준 레오와 슬러기두들에게\n감사드립니다!'
  },
  howToPlayHome: {
    title: {
      english: 'HOW TO PLAY YUTNORI',
      korean: '윷놀이 하는 법'
    },
    goal: {
      english: 'GOAL',
      korean: '목표'
    },
    goalDescription: {
      english: 'YUTNORI IS A BOARD GAME PLAYED WITH\nFOUR WOODEN STICKS CALLED YUT. THE\nGOAL IS TO MOVE ALL YOUR TOKENS AROUND\nTHE BOARD BEFORE THE OTHER TEAM DOES.',
      korean: '윷놀이는 윷이라고 불리는 네 개의 나무 막대기로\n하는 전통 한국 보드 게임입니다. 목표는 상대\n팀보다 먼저 모든 말을 보드를 돌아 나가는\n것입니다.'
    },
    theYut: {
      english: 'THE YUT (DICE)',
      korean: '윷 (주사위)'
    },
    theYutDescription: {
      english: 'THESE WOODEN STICKS ARE FLAT ON ONE SIDE\nAND ROUND ON THE OTHER. The way they land\ndetermines how many spaces you move.',
      korean: '이 막대기는 한쪽은 평평하고 다른 한쪽은\n둥글게 되어 있습니다. 떨어지는 방식에 따라\n이동할 칸 수가 결정됩니다.'
    },
    jump3Spaces: {
      english: 'Move\n3 SPACES',
      korean: '이동\n3칸'
    },
    howToReadYut: {
      english: 'HOW TO READ THE YUT',
      korean: '윷 읽는 법'
    },
    eachFlatSide: {
      english: 'EACH FLAT SIDE COUNTS AS ONE SPACE.',
      korean: '평평한 면 하나당 한 칸입니다.'
    },
    yutOrMoBonusFull: {
      english: 'IF YOU ROLL YUT OR MO, YOU GET TO\nTAKE THE MOVE AND THROW AGAIN.',
      korean: '윷이나 모를 던지면 한번 더 던집니다.'
    },
    yutOrMoBonus: {
      english: 'IF YOU ROLL YUT OR MO, YOU GET TO\nTAKE THE MOVE',
      korean: '윷이나 모를 던지면\n이동하고'
    },
    and: {
      english: 'AND',
      korean: '그리고'
    },
    throwAgain: {
      english: 'THROW AGAIN.',
      korean: '다시 던집니다.'
    },
    bigRolls: {
      english: 'BIG ROLLS CAN CHAIN TOGETHER AND\nSWING THE GAME.',
      korean: '큰 숫자가 연달아 나오면\n게임이 뒤집힐 수 있습니다.'
    },
    do: {
      english: 'DO',
      korean: '도'
    },
    gae: {
      english: 'GAE',
      korean: '개'
    },
    ge: {
      english: 'GE',
      korean: '개'
    },
    gul: {
      english: 'GUL',
      korean: '걸'
    },
    geol: {
      english: 'GEOL',
      korean: '걸'
    },
    yut: {
      english: 'YUT',
      korean: '윷'
    },
    mo: {
      english: 'MO',
      korean: '모'
    },
    backdo: {
      english: 'backdo',
      korean: '백도'
    },
    oneStickFlat: {
      english: 'ONE STICK FLAT',
      korean: '한 개 뒤집힘'
    },
    twoFlat: {
      english: 'TWO FLAT',
      korean: '두 개 뒤집힘'
    },
    threeFlat: {
      english: 'THREE FLAT',
      korean: '세 개 뒤집힘'
    },
    allFlat: {
      english: 'ALL FLAT',
      korean: '모두 뒤집힘'
    },
    allFourFlat: {
      english: 'ALL FOUR FLAT',
      korean: '네 개 모두 평평'
    },
    noFlat: {
      english: 'NO FLAT',
      korean: '안 뒤집힘'
    },
    allFourRound: {
      english: 'ALL FOUR ROUND',
      korean: '네 개 모두 둥글게'
    },
    oneSpace: {
      english: '1 SPACE',
      korean: '1칸'
    },
    twoSpaces: {
      english: '2 SPACES',
      korean: '2칸'
    },
    threeSpaces: {
      english: '3 SPACES',
      korean: '3칸'
    },
    fourSpaces: {
      english: '4 SPACES',
      korean: '4칸'
    },
    fiveSpaces: {
      english: '5 SPACES',
      korean: '5칸'
    },
    minusOneSpace: {
      english: '-1 SPACE',
      korean: '-1칸'
    },
    bonusTurn: {
      english: 'BONUS TURN',
      korean: '보너스 턴'
    },
    throwAgainShort: {
      english: 'THROW AGAIN!',
      korean: '다시 던지기!'
    },
    backward: {
      english: 'BACKWARD',
      korean: '뒤로'
    },
    moveBackward: {
      english: 'MOVE BACKWARD',
      korean: '뒤로 이동'
    },
    movement: {
      english: 'MOVEMENT',
      korean: '이동'
    },
    movementDescriptionFull: {
      english: 'Your pieces follow the path around\nthe board. There are SHORTCUTS at the\ncorners (planets) — if you land on one,\nyou can take the faster diagonal path.',
      korean: '말은 보드 주위의 경로를 따라갑니다. 모퉁이에\n(행성) 착륙하면 더 빠른 대각선 경로를 탈 수\n있습니다.'
    },
    movementDescription1: {
      english: 'Your pieces follow the path around\nthe board. There are',
      korean: '말은 보드 주위의 경로를\n따라갑니다.'
    },
    shortcuts: {
      english: 'SHORTCUTS',
      korean: '지름길'
    },
    movementDescription2: {
      english: 'at the\ncorners (planets) — if you land on one,\nyou can take the faster diagonal path.',
      korean: '이\n모퉁이(행성)에 있습니다 — 하나에\n착륙하면 더 빠른 대각선 경로를\n탈 수 있습니다.'
    },
    capturing: {
      english: 'CAPTURING',
      korean: '잡기'
    },
    capturingDescriptionFull: {
      english: 'If you land on your opponent\'s\npiece, you send it back to the start\nand you get another turn.',
      korean: '상대방의 말이랑 겹치면 상대방의 말을 시작점으로\n돌려보내고 한번 더 갑니다.'
    },
    capturingDescription1: {
      english: 'If you land on your opponent\'s\npiece, you send it back to the start\nand you get',
      korean: '상대방의 말 위에 착륙하면\n상대방의 말을 시작점으로\n돌려보내고'
    },
    anotherTurn: {
      english: 'another turn.',
      korean: '한 턴 더 갑니다.'
    },
    stacking: {
      english: 'STACKING',
      korean: '업기'
    },
    stackingDescription: {
      english: 'You can land two of your own pieces\non the same spot to stack them.\nThey move together as one.',
      korean: '같은 팀의 말에 도착하면 업습니다. 다음부터 같이\n움직입니다.'
    },
    winningTheGame: {
      english: 'WINNING THE GAME',
      korean: '이기는 방법'
    },
    winningDescription: {
      english: 'Be the first team to move all of your\npieces around the board and off the\nfinish point.',
      korean: '첫 번째로 모든 말을\n보드를 돌아 결승점에서\n나가게 한 팀이 승리합니다.'
    },
    tipsForBeginners: {
      english: 'TIPS FOR BEGINNERS',
      korean: '초보자를 위한 팁'
    },
    tip1: {
      english: 'Try to capture pieces — extra turns\nare powerful.',
      korean: '말을 잡으세요. 한번 더 윷을 던져서\n유리합니다.'
    },
    tip2: {
      english: 'Use the diagonal shortcut when\npossible.',
      korean: '가능하면 대각선 지름길을\n이용하세요.'
    },
    tip3: {
      english: 'Stack your pieces to move faster,\nbut don\'t get both captured at once.',
      korean: '빠르게 이동하기 위해 말을\n쌓으세요. 하지만 한꺼번에\n둘 다 잡히지 않도록 하세요.'
    },
    tip4: {
      english: 'Use your bonus throws before making\na move.',
      korean: '움직이기 전에 윷을 먼저 던지세요.'
    },
    backdoTip: {
      english: 'A TOKEN ON THE FIRST SPACE CAN MOVE\nTO THE FINISH WITH A BACKDO.',
      korean: '첫 번째 칸에 있는 말은\n뒷도로 결승점으로 갈 수 있습니다.'
    },
    catch: {
      english: 'CATCH!',
      korean: '잡았다!'
    },
    piggyback: {
      english: 'PIGGYBACK!',
      korean: '업었다!'
    },
    welcomeHome: {
      english: 'WELCOME\n    HOME!',
      korean: '났다!'
    },
    bonusTurnAlert: {
      english: 'BONUS\n TURN!',
      korean: '보너스\n 턴!'
    },
    missionAccomplished: {
      english: 'MISSION\nACCOMPLISHED!',
      korean: '미션\n달성!'
    },
    yutDice: {
      english: 'YUT\n(DICE)',
      korean: '윷\n(주사위)'
    },
    moves: {
      english: 'MOVES:',
      korean: '이동:'
    },
    move: {
      english: 'MOVE',
      korean: '이동'
    },
    read: {
      english: 'READ',
      korean: '읽기'
    },
    mainMenu: {
      english: 'MAIN MENU',
      korean: '메인 메뉴'
    },
    contents: {
      english: 'CONTENTS',
      korean: '목차'
    },
    tab1Goal: {
      english: '1. GOAL',
      korean: '1. 목표'
    },
    tab2ThrowTheYut: {
      english: '2. THROW THE YUT',
      korean: '2. 윷 던지기'
    },
    tab3ReadTheYut: {
      english: '3. READ THE YUT',
      korean: '3. 윷 읽기'
    },
    tab4Movement: {
      english: '4. MOVEMENT',
      korean: '4. 이동'
    },
    tab5CatchEnemies: {
      english: '5. CATCH ENEMIES',
      korean: '5. 상대 잡기'
    },
    tab6Piggyback: {
      english: '6. PIGGYBACK',
      korean: '6. 업기'
    },
    tab7Winning: {
      english: '7. WINNING',
      korean: '7. 이기기'
    },
    tab8Tips: {
      english: '8. TIPS',
      korean: '8. 팁'
    }
  },
  gameSettings: {
    backdoLaunch: {
      english: 'BACKDO RULE',
      korean: '뒷도 출발',
      spanish: 'LANZAMIENTO BACKDO',
      chinese: '后道发射'
    },
    backdoLaunchDescription: {
      english: 'NO TOKENS ON THE BOARD? BACKDO\n(-1) PUTS ONE ON EARTH.',
      korean: '뒷도를 던졌을 때 판 위에\n말이 없으면 지구에 말을 놓습니다.',
      spanish: 'SIN FICHAS EN EL TABLERO?\nBACKDO (-1): UNA EN TIERRA.',
      chinese: '掷出后道(-1)且无棋子时，\n在地球放置一枚棋子。'
    },
    timer: {
      english: 'TIMER',
      korean: '타이머',
      spanish: 'TEMPORIZADOR',
      chinese: '计时器'
    },
    timerDescription: {
      english: '1 MINUTE TIME LIMIT PER TURN.',
      korean: '턴당 1분 시간 제한.',
      spanish: 'LÍMITE DE TIEMPO DE 1 MINUTO POR TURNO.',
      chinese: '每回合1分钟时间限制。'
    },
    nakThrow: {
      english: 'NAK THROW',
      korean: '낙 던지기',
      spanish: 'LANZAMIENTO NAK',
      chinese: '落掷'
    },
    nakThrowDescription: {
      english: 'THE STICKS WILL SOMETIMES FALL\nOUT OF BOUNDS.',
      korean: '윷이 가끔 경계 밖으로\n떨어집니다.',
      spanish: 'LOS PALOS A VECES CAERÁN\nFUERA DE LÍMITES.',
      chinese: '木棍有时会掉出\n界外。'
    },
    bonusThrowCatch: {
      english: 'YUTMO CATCH',
      korean: '윷모 잡기',
      spanish: 'CAPTURA DE YUTMO',
      chinese: '奖励投掷捕获'
    },
    bonusThrowCatchDescription: {
      english: 'GET ANOTHER TURN, EVEN WHEN\nYOU CATCH WITH A YUT OR MO.',
      korean: '윷이나 모로 잡아도\n한 번 더 던집니다.',
      chinese: '即使用擲木或莫吃子，\n也能获得额外回合。'
    },
    minigameDescription: {
      english: 'PLAY GAMES TO WIN A BONUS YUT!',
      korean: '게임으로 보너스 윷을 획득하세요!',
      spanish: 'JUEGA Y GANA UN YUT BONUS!',
      chinese: '玩游戏赢取额外擲木！'
    },
    minigame: {
      english: 'MINIGAME',
      korean: '미니게임',
      spanish: 'MINIJUEGO',
      chinese: '小游戏'
    },
    splitPaths: {
      english: 'LONG PATH',
      korean: '길 돌아 가기',
      spanish: 'CAMINOS DIVIDIDOS',
      chinese: '分路'
    },
    splitPathsDescription: {
      english: 'LETS YOU CHOOSE THE LONG PATH\nFROM A SHORTCUT (PLANET).',
      korean: '지름길(행성)에서 긴 경로를\n선택할 수 있습니다.',
      spanish: 'TE PERMITE ELEGIR EL CAMINO LARGO\nDESDE UN ATAJO (PLANETA).',
      chinese: '让你从捷径（行星）\n选择长路径。'
    }
  },
  lobby: {
    teamRocket: {
      english: 'TEAM\nROCKET',
      korean: '로켓팀'
    },
    teamUfo: {
      english: 'TEAM\nUFO',
      korean: '외계인팀'
    },
    yutNori: {
      english: 'YUT NORI!',
      korean: '우주 윷놀이!'
    },
    yutNoriTitle: {
      english: 'YUT NORI',
      korean: '윷놀이'
    },
    roomId: {
      english: 'ROOM ID',
      korean: '방 번호'
    },
    host: {
      english: 'HOST',
      korean: '방장'
    },
    rulebook: {
      english: 'RULEBOOK',
      korean: '설명서'
    },
    sound: {
      english: 'SOUND',
      korean: '소리'
    },
    inviteFriends: {
      english: 'INVITE FRIENDS',
      korean: '친구 초대'
    },
    settings: {
      english: 'SETTINGS',
      korean: '설정'
    },
    scanQrCode: {
      english: 'SCAN THE QR CODE TO JOIN\nTHIS ROOM, OR COPY THE\nLINK AND SHARE WITH\nYOUR FRIENDS',
      korean: 'QR 코드를 스캔하거나 링크를\n복사해서 친구들과 공유하세요'
    },
    copyLink: {
      english: 'COPY LINK',
      korean: '링크 복사'
    },
    copied: {
      english: 'copied!',
      korean: '복사됨!'
    },
    startGame: {
      english: 'START GAME!',
      korean: '게임 시작!'
    },
    waitingForCrew: {
      english: 'WAITING FOR CREW...',
      korean: '비행사 대기 중...'
    },
    hostWillStart: {
      english: 'HOST WILL START',
      korean: '방장 대기 중'
    },
    shareThisLobby: {
      english: 'SHARE THIS LOBBY',
      korean: '방 공유하기'
    },
    readyToStart: {
      english: "I'M READY!",
      korean: '준비 완료!'
    },
    players: {
      english: 'PLAYERS',
      korean: '플레이어'
    },
    selectLanguage: {
      english: 'SELECT LANGUAGE',
      korean: '언어 선택'
    },
    close: {
      english: 'X CLOSE',
      korean: 'X 닫기'
    },
    takeSeat: {
      english: 'TAKE SEAT',
      korean: '자리 앉기'
    },
    addAIEZ: {
      english: 'ADD AI - EZ',
      korean: 'AI 추가 - 쉬움'
    },
    addAI: {
      english: 'ADD AI',
      korean: 'AI 추가'
    },
    assignHost: {
      english: 'ASSIGN HOST',
      korean: '호스트 지정'
    },
    kick: {
      english: 'KICK',
      korean: '추방'
    },
    setSpectator: {
      english: 'SET SPECTATOR',
      korean: '관전자로 바꾸기'
    },
    edit: {
      english: 'EDIT',
      korean: '설정'
    },
    clickToSit: {
      english: 'CLICK TO SIT',
      korean: '클릭하여 앉기'
    },
    openSeat: {
      english: 'OPEN SEAT',
      korean: '빈 자리'
    },
    joinTheRockets: {
      english: 'Join the',
      korean: '참여하세요'
    },
    rockets: {
      english: 'rockets',
      korean: '로켓'
    },
    ufos: {
      english: 'ufos',
      korean: 'UFO'
    },
    as: {
      english: 'as',
      korean: ''
    },
    namePlaceholder: {
      english: 'name...',
      korean: '이름...'
    },
    leggo: {
      english: 'LEGGO!',
      korean: '가자!'
    },
    nah: {
      english: 'NAH',
      korean: '취소'
    }
  },
  game: {
    viewer: {
      english: 'VIEWER',
      korean: '관전'
    },
    aiPlaying: {
      english: 'AI playing',
      korean: 'AI 하는 중'
    },
    host: {
      english: 'HOST',
      korean: '방장'
    },
    teamNames: {
      rockets: {
        english: 'ROCKETS',
        korean: '로켓팀'
      },
      ufos: {
        english: 'UFOS',
        korean: '외계인팀'
      }
    },
    throw: {
      english: 'THROW',
      korean: '던져랏!'
    },
    bonus: {
      english: 'BONUS',
      korean: '한번더!'
    },
    pregame: {
      english: 'PREGAME',
      korean: '선잡기'
    },
    rules: {
      english: 'RULES',
      korean: '설명서'
    },
    settings: {
      english: 'SETTINGS',
      korean: '설정'
    },
    chat: {
      english: 'CHAT',
      korean: '채팅'
    },
    logs: {
      english: 'LOGS',
      korean: '로그'
    },
    moves: {
      english: 'MOVES',
      korean: '윷말'
    },
    whoGoesFirst: {
      title: {
        english: 'Who goes first?',
        korean: '선 잡기'
      },
      description: {
        english: 'One player from each team throws\nthe yoot. The team with a higher\nnumber goes first.',
        korean: '각 팀에서 한 명이 윷을 던집니다.\n더 높은 숫자가 나온 팀이\n먼저 시작합니다.'
      }
    },
    resetGame: {
      english: 'RESET GAME',
      korean: '게임 초기화'
    },
    quit: {
      english: 'QUIT',
      korean: '나가기'
    },
    back: {
      english: 'BACK',
      korean: '뒤로'
    },
    editGuests: {
      english: 'EDIT GUESTS',
      korean: '플레이어 설정'
    },
    setReturned: {
      english: 'SET RETURNED',
      korean: '복귀'
    },
    setAway: {
      english: 'SET AWAY',
      korean: '자리 비움'
    },
    pauseGame: {
      english: 'PAUSE GAME',
      korean: '일시 정지'
    },
    unpause: {
      english: 'UNPAUSE',
      korean: '재개'
    },
    setGameRules: {
      english: 'SET GAME RULES',
      korean: '게임 규칙 설정'
    },
    viewGuests: {
      english: 'VIEW GUESTS',
      korean: '손님 보기'
    },
    viewGameRules: {
      english: 'GAME RULES',
      korean: '게임 규칙 보기'
    },
    menu: {
      english: 'MENU',
      korean: '메뉴'
    },
    actions: {
      english: 'ACTIONS',
      korean: '설정'
    },
    hostYou: {
      english: 'HOST     YOU',
      korean: '방장     나'
    },
    setTeamToRockets: {
      english: 'SET TEAM TO ROCKETS',
      korean: '로켓 팀으로 변경'
    },
    setTeamToUfos: {
      english: 'SET TEAM TO UFOS',
      korean: 'UFO 팀으로 변경'
    },
    assignHost: {
      english: 'ASSIGN HOST',
      korean: '방장 위임'
    },
    kick: {
      english: 'KICK',
      korean: '강퇴'
    },
    setSpectator: {
      english: 'SET SPECTATOR',
      korean: '관전자로 변경'
    },
    edit: {
      english: 'EDIT',
      korean: '설정'
    },
    resetGameWarning: {
      english: 'ALL PROGRESS WILL BE ERASED.\nARE YOU SURE?',
      korean: '모든 진행 상황이 지워집니다.\n확실합니까?'
    },
    yes: {
      english: 'YES',
      korean: '네'
    },
    no: {
      english: 'NO',
      korean: '아니오'
    },
    you: {
      english: 'YOU',
      korean: '나'
    },
    saySomething: {
      english: 'say something...',
      korean: '메시지 입력...'
    }
  },
  alerts: {
    timesUp: {
      english: 'TIMES\nUP!',
      korean: '시간\n종료!'
    },
    paused: {
      english: 'PAUSED',
      korean: '잠깐 쉼'
    },
    unpause: {
      english: 'UNPAUSE',
      korean: '가자!'
    },
    do: {
      english: 'DO',
      korean: '도'
    },
    ge: {
      english: 'GE',
      korean: '개'
    },
    gul: {
      english: 'GUL',
      korean: '걸'
    },
    yoot: {
      english: 'YOOT',
      korean: '윷'
    },
    mo: {
      english: 'MO',
      korean: '모'
    },
    backdo: {
      english: 'BACKDO',
      korean: '뒷도'
    },
    noToken: {
      english: 'NO TOKEN',
      korean: '말 없음'
    },
    catch: {
      english: 'CATCH!',
      korean: '잡았당!'
    },
    bonusThrow: {
      english: 'BONUS THROW',
      korean: '한번더!'
    },
    rocketsWin: {
      english: 'ROCKETS WIN!',
      korean: '로켓팀 시작!'
    },
    ufosWin: {
      english: 'UFOS WIN!',
      korean: '외계인팀\n시작!'
    },
    tie: {
      english: 'TIE!',
      korean: '비김'
    },
    goAgain: {
      english: 'GO AGAIN!',
      korean: '한번더'
    },
    out: {
      english: 'OUT',
      korean: '낙'
    },
    lostInSpace: {
      english: 'THROWN OUT...',
      korean: '우주로 낙방...'
    },
    allClear: {
      english: 'ALL CLEAR!',
      korean: '싹쓸이!'
    },
    yourTurn: {
      english: 'YOUR TURN!',
      korean: '던져랏!'
    },
    welcomeBack: {
      english: 'Welcome\n     Back!',
      korean: '났다!'
    },
    alienInvasion: {
      english: '     ALIEN\nINVASION!',
      korean: '났다!'
    },
    piggyback: {
      english: 'piggyback!',
      korean: '업었당!'
    },
    gameStart: {
      english: 'GAME\nSTART!',
      korean: '게임\n시작!'
    },
    disconnected: {
      english: 'Disconnected from\nserver. Reconnecting',
      korean: '서버 연결 끊김.\n재연결 중'
    },
    refresh: {
      english: 'refresh',
      korean: '새로고침'
    }
  },
  endScenes: {
    missionAbort: {
      english: 'MISSION ABORT!',
      korean: '졌당..'
    },
    rockets: {
      english: 'ROCKETS',
      korean: '로켓팀'
    },
    ufos: {
      english: 'UFOS',
      korean: '외계인팀'
    },
    roomId: {
      english: 'ROOM ID',
      korean: '방 번호'
    },
    lostInSpace: {
      english: 'LOST IN SPACE!',
      korean: '졌당..'
    },
    missionAccomplished: {
      english: 'MISSION\nACCOMPLISHED!',
      korean: '앗싸바리!'
    },
    alienInvasion: {
      english: 'ALIEN INVASION!',
      korean: '아싸바리!'
    },
    playAgain: {
      english: 'PLAY AGAIN',
      korean: '다시 하기'
    },
    shareLink: {
      english: 'SHARE LINK',
      korean: '링크 공유'
    },
    discord: {
      english: 'DISCORD',
      korean: '디스코드'
    }
  },
  subtitle: {
    english: 'K-BOARD GAME',
    korean: '지구를 넘은 민속 놀이'
  }
}

const spanishByEnglish = {
  'ENGLISH': 'INGLÉS',
  'LANGUAGE': 'IDIOMA',
  'YUT': 'YUT',
  'NORI': 'NORI',
  'How To Play': 'Cómo jugar',
  'Host a game': 'CREAR PARTIDA',
  'Join a game': 'UNIRSE',
  'SHOWROOM': 'GALERÍA',
  'ABOUT': 'ACERCA DE',
  'NEW!': '¡NUEVO!',
  'MOBILE CONTROLS ARE ENHANCED!\nDIRECT THE SHIPS WITH BUTTONS CLOSER\nTO YOUR THUMB.\n\nKOREAN CHARACTERS CAN NOW BE\nPROPERLY TYPED IN THE CHATBOX.\n\nTHANK YOU TO *LEO* AND *SLUGGYDOODLE*\nFOR REPORTING THIS ISSUE ON DISCORD!': '¡LOS CONTROLES MÓVILES HAN MEJORADO!\nDIRIGE LAS NAVES CON BOTONES MÁS CERCA\nDE TU PULGAR.\n\nAHORA PUEDES ESCRIBIR CARACTERES COREANOS\nCORRECTAMENTE EN EL CHAT.\n\n¡GRACIAS A *LEO* Y *SLUGGYDOODLE*\nPOR INFORMAR ESTE PROBLEMA EN DISCORD!',
  'HOW TO PLAY YUTNORI': 'CÓMO JUGAR YUTNORI',
  'GOAL': 'OBJETIVO',
  'YUTNORI IS A BOARD GAME PLAYED WITH\nFOUR WOODEN STICKS CALLED YUT. THE\nGOAL IS TO MOVE ALL YOUR TOKENS AROUND\nTHE BOARD BEFORE THE OTHER TEAM DOES.': 'YUTNORI ES UN JUEGO DE MESA QUE SE JUEGA\nCON CUATRO PALOS DE MADERA LLAMADOS YUT.\nEL OBJETIVO ES MOVER TODAS TUS PIEZAS POR\nEL TABLERO ANTES QUE EL OTRO EQUIPO.',
  'THE YUT (DICE)': 'EL YUT (DADOS)',
  'THESE WOODEN STICKS ARE FLAT ON ONE SIDE\nAND ROUND ON THE OTHER. The way they land\ndetermines how many spaces you move.': 'ESTOS PALOS DE MADERA SON PLANOS POR UN LADO\nY REDONDOS POR EL OTRO. LA FORMA EN QUE CAEN\nDETERMINA CUÁNTOS ESPACIOS AVANZAS.',
  'Move\n3 SPACES': 'Mueve\n3 ESPACIOS',
  'HOW TO READ THE YUT': 'CÓMO LEER EL YUT',
  'EACH FLAT SIDE COUNTS AS ONE SPACE.': 'CADA LADO PLANO CUENTA COMO UN ESPACIO.',
  'IF YOU ROLL YUT OR MO, YOU GET TO\nTAKE THE MOVE AND THROW AGAIN.': 'SI SACAS YUT O MO, PUEDES\nMOVER Y LANZAR DE NUEVO.',
  'IF YOU ROLL YUT OR MO, YOU GET TO\nTAKE THE MOVE': 'SI SACAS YUT O MO, PUEDES\nHACER EL MOVIMIENTO',
  'AND': 'Y',
  'THROW AGAIN.': 'LANZAR DE NUEVO.',
  'BIG ROLLS CAN CHAIN TOGETHER AND\nSWING THE GAME.': 'LAS TIRADAS GRANDES PUEDEN ENCADENARSE\nY CAMBIAR EL RUMBO DE LA PARTIDA.',
  'DO': 'DO',
  'GAE': 'GAE',
  'GE': 'GE',
  'GUL': 'GUL',
  'GEOL': 'GEOL',
  'MO': 'MO',
  'backdo': 'backdo',
  'ONE STICK FLAT': 'UN PALO PLANO',
  'TWO FLAT': 'DOS PLANOS',
  'THREE FLAT': 'TRES PLANOS',
  'ALL FLAT': 'TODOS PLANOS',
  'ALL FOUR FLAT': 'LOS CUATRO PLANOS',
  'NO FLAT': 'NINGUNO PLANO',
  'ALL FOUR ROUND': 'LOS CUATRO REDONDOS',
  '1 SPACE': '1 ESPACIO',
  '2 SPACES': '2 ESPACIOS',
  '3 SPACES': '3 ESPACIOS',
  '4 SPACES': '4 ESPACIOS',
  '5 SPACES': '5 ESPACIOS',
  '-1 SPACE': '-1 ESPACIO',
  'BONUS TURN': 'TURNO EXTRA',
  'THROW AGAIN!': '¡LANZA DE NUEVO!',
  'BACKWARD': 'HACIA ATRÁS',
  'MOVE BACKWARD': 'MUEVE HACIA ATRÁS',
  'MOVEMENT': 'MOVIMIENTO',
  'Your pieces follow the path around\nthe board. There are SHORTCUTS at the\ncorners (planets) — if you land on one,\nyou can take the faster diagonal path.': 'TUS PIEZAS SIGUEN EL CAMINO ALREDEDOR\nDEL TABLERO. HAY ATAJOS EN LAS\nESQUINAS (PLANETAS): AL LLEGAR A UNO,\nPUEDES TOMAR LA RUTA DIAGONAL MÁS RÁPIDA.',
  'Your pieces follow the path around\nthe board. There are': 'Tus piezas siguen el camino alrededor\ndel tablero. Hay',
  'SHORTCUTS': 'ATAJOS',
  'at the\ncorners (planets) — if you land on one,\nyou can take the faster diagonal path.': 'en las\nesquinas (planetas): si llegas a uno,\npuedes tomar la ruta diagonal más rápida.',
  'CAPTURING': 'CAPTURA',
  "If you land on your opponent's\npiece, you send it back to the start\nand you get another turn.": 'Si llegas a una pieza del rival,\nla devuelves al inicio\ny obtienes otro turno.',
  "If you land on your opponent's\npiece, you send it back to the start\nand you get": 'Si llegas a una pieza del rival,\nla devuelves al inicio\ny obtienes',
  'another turn.': 'otro turno.',
  'STACKING': 'APILAR',
  'You can land two of your own pieces\non the same spot to stack them.\nThey move together as one.': 'Puedes colocar dos piezas propias\nen el mismo lugar para apilarlas.\nSe mueven juntas como una sola.',
  'WINNING THE GAME': 'GANAR LA PARTIDA',
  'Be the first team to move all of your\npieces around the board and off the\nfinish point.': 'Sé el primer equipo en mover todas sus\npiezas por el tablero y sacarlas\nde la meta.',
  'TIPS FOR BEGINNERS': 'CONSEJOS PARA PRINCIPIANTES',
  'Try to capture pieces — extra turns\nare powerful.': 'Intenta capturar piezas: los turnos extra\nson muy poderosos.',
  'Use the diagonal shortcut when\npossible.': 'Usa el atajo diagonal\ncuando puedas.',
  "Stack your pieces to move faster,\nbut don't get both captured at once.": 'Apila tus piezas para moverte más rápido,\npero evita que capturen ambas a la vez.',
  'Use your bonus throws before making\na move.': 'Usa tus lanzamientos extra antes\nde hacer un movimiento.',
  'A TOKEN ON THE FIRST SPACE CAN MOVE\nTO THE FINISH WITH A BACKDO.': 'UNA PIEZA EN EL PRIMER ESPACIO PUEDE LLEGAR\nA LA META CON UN BACKDO.',
  'CATCH!': '¡CAPTURA!',
  'PIGGYBACK!': '¡APILADAS!',
  'WELCOME\n    HOME!': '¡BIENVENIDA\n    A CASA!',
  'BONUS\n TURN!': '¡TURNO\n EXTRA!',
  'MISSION\nACCOMPLISHED!': '¡MISIÓN\nCUMPLIDA!',
  'YUT\n(DICE)': 'YUT\n(DADOS)',
  'MOVES:': 'MOVIMIENTOS:',
  'MOVE': 'MOVER',
  'READ': 'LEER',
  'MAIN MENU': 'MENÚ PRINCIPAL',
  'CONTENTS': 'CONTENIDO',
  '1. GOAL': '1. OBJETIVO',
  '2. THROW THE YUT': '2. LANZAR EL YUT',
  '3. READ THE YUT': '3. LEER EL YUT',
  '4. MOVEMENT': '4. MOVIMIENTO',
  '5. CATCH ENEMIES': '5. CAPTURAR RIVALES',
  '6. PIGGYBACK': '6. APILAR',
  '7. WINNING': '7. GANAR',
  '8. TIPS': '8. CONSEJOS',
  'GET ANOTHER TURN, EVEN WHEN\nYOU CATCH WITH A YUT OR MO.': 'OBTÉN OTRO TURNO AUN SI\nCAPTURAS CON YUT O MO.',
  'TEAM\nROCKET': 'EQUIPO\nCOHETE',
  'TEAM\nUFO': 'EQUIPO\nOVNI',
  'YUT NORI!': '¡YUT NORI!',
  'YUT NORI': 'YUT NORI',
  'ROOM ID': 'ID DE SALA',
  'HOST': 'ANFITRIÓN',
  'RULEBOOK': 'REGLAS',
  'SOUND': 'SONIDO',
  'INVITE FRIENDS': 'INVITAR AMIGOS',
  'SETTINGS': 'AJUSTES',
  'SCAN THE QR CODE TO JOIN\nTHIS ROOM, OR COPY THE\nLINK AND SHARE WITH\nYOUR FRIENDS': 'ESCANEA EL CÓDIGO QR PARA UNIRTE\nA ESTA SALA O COPIA EL\nENLACE Y COMPÁRTELO CON\nTUS AMIGOS',
  'COPY LINK': 'COPIAR ENLACE',
  'copied!': '¡copiado!',
  'START GAME!': '¡INICIAR PARTIDA!',
  'WAITING FOR CREW...': 'ESPERANDO A LA TRIPULACIÓN...',
  'HOST WILL START': 'EL ANFITRIÓN INICIARÁ',
  'SHARE THIS LOBBY': 'COMPARTIR ESTA SALA',
  "I'M READY!": '¡ESTOY LISTO!',
  'PLAYERS': 'JUGADORES',
  'SELECT LANGUAGE': 'SELECCIONA IDIOMA',
  'X CLOSE': 'X CERRAR',
  'TAKE SEAT': 'OCUPAR ASIENTO',
  'ADD AI - EZ': 'AÑADIR IA - FÁCIL',
  'ADD AI': 'AÑADIR IA',
  'ASSIGN HOST': 'ASIGNAR ANFITRIÓN',
  'KICK': 'EXPULSAR',
  'SET SPECTATOR': 'HACER ESPECTADOR',
  'EDIT': 'EDITAR',
  'CLICK TO SIT': 'CLIC PARA SENTARSE',
  'OPEN SEAT': 'ASIENTO LIBRE',
  'Join the': 'Únete a',
  'rockets': 'cohetes',
  'ufos': 'ovnis',
  'as': 'como',
  'name...': 'nombre...',
  'LEGGO!': '¡VAMOS!',
  'NAH': 'NO',
  'VIEWER': 'ESPECTADOR',
  'AI playing': 'IA jugando',
  'ROCKETS': 'COHETES',
  'UFOS': 'OVNIS',
  'THROW': 'LANZAR',
  'BONUS': 'EXTRA',
  'PREGAME': 'PREPARTIDA',
  'RULES': 'REGLAS',
  'CHAT': 'CHAT',
  'LOGS': 'REGISTRO',
  'MOVES': 'PASOS',
  'Who goes first?': '¿Quién empieza?',
  'One player from each team throws\nthe yoot. The team with a higher\nnumber goes first.': 'Un jugador de cada equipo lanza\nel yut. El equipo con el número\nmás alto empieza.',
  'RESET GAME': 'REINICIAR PARTIDA',
  'QUIT': 'SALIR',
  'BACK': 'ATRÁS',
  'EDIT GUESTS': 'EDITAR JUGADORES',
  'SET RETURNED': 'MARCAR REGRESO',
  'SET AWAY': 'MARCAR AUSENTE',
  'PAUSE GAME': 'PAUSAR PARTIDA',
  'UNPAUSE': 'REANUDAR',
  'SET GAME RULES': 'CONFIGURAR REGLAS',
  'VIEW GUESTS': 'VER JUGADORES',
  'GAME RULES': 'VER REGLAS',
  'MENU': 'MENÚ',
  'ACTIONS': 'ACCIONES',
  'HOST     YOU': 'ANFITRIÓN     TÚ',
  'SET TEAM TO ROCKETS': 'CAMBIAR A COHETES',
  'SET TEAM TO UFOS': 'CAMBIAR A OVNIS',
  'ALL PROGRESS WILL BE ERASED.\nARE YOU SURE?': 'TODO EL PROGRESO SE BORRARÁ.\n¿ESTÁS SEGURO?',
  'YES': 'SÍ',
  'NO': 'NO',
  'YOU': 'TÚ',
  'say something...': 'di algo...',
  'TIMES\nUP!': '¡TIEMPO\nAGOTADO!',
  'PAUSED': 'EN PAUSA',
  'YOOT': 'YUT',
  'BACKDO': 'BACKDO',
  'NO TOKEN': 'SIN PIEZAS',
  'BONUS THROW': 'LANZAMIENTO EXTRA',
  'ROCKETS WIN!': '¡GANAN LOS COHETES!',
  'UFOS WIN!': '¡GANAN LOS OVNIS!',
  'TIE!': '¡EMPATE!',
  'GO AGAIN!': '¡OTRA VEZ!',
  'OUT': 'FUERA',
  'THROWN OUT...': 'EXPULSADO...',
  'ALL CLEAR!': '¡TODO DESPEJADO!',
  'YOUR TURN!': '¡TU TURNO!',
  'Welcome\n     Back!': '¡BIENVENIDO\n     DE VUELTA!',
  '     ALIEN\nINVASION!': '     ¡INVASIÓN\nALIENÍGENA!',
  'piggyback!': '¡apiladas!',
  'GAME\nSTART!': '¡COMIENZA\nLA PARTIDA!',
  'Disconnected from\nserver. Reconnecting': 'Desconectado del\nservidor. Reconectando',
  'refresh': 'recargar',
  'MISSION ABORT!': '¡MISIÓN ABORTADA!',
  'LOST IN SPACE!': '¡PERDIDO EN EL ESPACIO!',
  'ALIEN INVASION!': '¡INVASIÓN ALIENÍGENA!',
  'PLAY AGAIN': 'JUGAR DE NUEVO',
  'SHARE LINK': 'COMPARTIR ENLACE',
  'DISCORD': 'DISCORD',
  'K-BOARD GAME': 'JUEGO COREANO'
}

const chineseByEnglish = {
  'YUT': '擲木', 'NORI': '游戏', 'How To Play': '玩法说明', 'Host a game': '创建游戏', 'Join a game': '加入游戏',
  'SHOWROOM': '展厅', 'ABOUT': '关于', 'NEW!': '新！',
  'MOBILE CONTROLS ARE ENHANCED!\nDIRECT THE SHIPS WITH BUTTONS CLOSER\nTO YOUR THUMB.\n\nKOREAN CHARACTERS CAN NOW BE\nPROPERLY TYPED IN THE CHATBOX.\n\nTHANK YOU TO *LEO* AND *SLUGGYDOODLE*\nFOR REPORTING THIS ISSUE ON DISCORD!': '移动端控制已优化！\n使用更靠近拇指的按钮\n操控飞船。\n\n现在可以在聊天框中\n正确输入韩文。\n\n感谢 *LEO* 和 *SLUGGYDOODLE*\n在 DISCORD 上报告此问题！',
  'HOW TO PLAY YUTNORI': '擲戲玩法', 'GOAL': '目标',
  'YUTNORI IS A BOARD GAME PLAYED WITH\nFOUR WOODEN STICKS CALLED YUT. THE\nGOAL IS TO MOVE ALL YOUR TOKENS AROUND\nTHE BOARD BEFORE THE OTHER TEAM DOES.': '擲戲是一种使用四根木棒进行的\n传统棋盘游戏。目标是在对方队伍之前，\n让你的所有棋子绕过棋盘\n并到达终点。',
  'THE YUT (DICE)': '擲木（骰子）', 'THESE WOODEN STICKS ARE FLAT ON ONE SIDE\nAND ROUND ON THE OTHER. The way they land\ndetermines how many spaces you move.': '这些木棒一面平坦，另一面圆润。\n落地的方式决定了\n你可以移动多少格。',
  'Move\n3 SPACES': '移动\n3格', 'HOW TO READ THE YUT': '如何判读擲木', 'EACH FLAT SIDE COUNTS AS ONE SPACE.': '每个平面算一格。',
  'IF YOU ROLL YUT OR MO, YOU GET TO\nTAKE THE MOVE AND THROW AGAIN.': '掷出擲木或莫时，可以移动后\n再掷一次。', 'IF YOU ROLL YUT OR MO, YOU GET TO\nTAKE THE MOVE': '掷出擲木或莫时，\n可以移动',
  'AND': '并且', 'THROW AGAIN.': '再掷一次。', 'BIG ROLLS CAN CHAIN TOGETHER AND\nSWING THE GAME.': '大点数可以连续出现，\n扭转战局。',
  'DO': '道', 'GAE': '开', 'GE': '开', 'GUL': '乞', 'GEOL': '乞', 'MO': '莫', 'backdo': '后道',
  'ONE STICK FLAT': '一根平面朝上', 'TWO FLAT': '两个平面朝上', 'THREE FLAT': '三个平面朝上', 'ALL FLAT': '全部平面朝上',
  'ALL FOUR FLAT': '四个全部平面朝上', 'NO FLAT': '没有平面朝上', 'ALL FOUR ROUND': '四个全部圆面朝上',
  '1 SPACE': '1格', '2 SPACES': '2格', '3 SPACES': '3格', '4 SPACES': '4格', '5 SPACES': '5格', '-1 SPACE': '-1格',
  'BONUS TURN': '奖励回合', 'THROW AGAIN!': '再掷一次！', 'BACKWARD': '后退', 'MOVE BACKWARD': '向后移动', 'MOVEMENT': '移动',
  'Your pieces follow the path around\nthe board. There are SHORTCUTS at the\ncorners (planets) — if you land on one,\nyou can take the faster diagonal path.': '棋子沿着棋盘路径前进。角落的\n行星处有捷径，落在其上时\n可以选择更快的对角路线。',
  'Your pieces follow the path around\nthe board. There are': '棋子沿着棋盘路径前进。\n这里有', 'SHORTCUTS': '捷径',
  'at the\ncorners (planets) — if you land on one,\nyou can take the faster diagonal path.': '位于角落（行星）的\n捷径。落在其上时，\n可以走更快的对角路线。',
  'CAPTURING': '吃子', "If you land on your opponent's\npiece, you send it back to the start\nand you get another turn.": '落在对方棋子上时，\n将其送回起点，\n并获得额外回合。',
  "If you land on your opponent's\npiece, you send it back to the start\nand you get": '落在对方棋子上时，\n将其送回起点，\n并获得', 'another turn.': '额外回合。',
  'STACKING': '叠子', 'You can land two of your own pieces\non the same spot to stack them.\nThey move together as one.': '两个己方棋子可以落在同一格叠放。\n之后它们会作为一个整体\n一起移动。',
  'WINNING THE GAME': '获胜方式', 'Be the first team to move all of your\npieces around the board and off the\nfinish point.': '率先让所有棋子绕过棋盘\n并离开终点的队伍\n获得胜利。',
  'TIPS FOR BEGINNERS': '新手提示', 'Try to capture pieces — extra turns\nare powerful.': '尽量吃掉对方棋子，\n额外回合非常有利。', 'Use the diagonal shortcut when\npossible.': '尽可能使用\n对角捷径。',
  "Stack your pieces to move faster,\nbut don't get both captured at once.": '叠放棋子可以更快移动，\n但不要让它们同时被吃掉。', 'Use your bonus throws before making\na move.': '移动之前使用\n额外投掷机会。',
  'A TOKEN ON THE FIRST SPACE CAN MOVE\nTO THE FINISH WITH A BACKDO.': '第一格上的棋子可以通过后道\n直接移动到终点。',
  'CATCH!': '吃子！', 'PIGGYBACK!': '叠子！', 'WELCOME\n    HOME!': '回到\n    家园！', 'BONUS\n TURN!': '奖励\n 回合！',
  'MISSION\nACCOMPLISHED!': '任务\n完成！', 'YUT\n(DICE)': '擲木\n（骰子）', 'MOVES:': '步数：', 'MOVE': '移动', 'READ': '判读', 'MAIN MENU': '主菜单', 'CONTENTS': '目录',
  '1. GOAL': '1. 目标', '2. THROW THE YUT': '2. 掷擲木', '3. READ THE YUT': '3. 判读擲木', '4. MOVEMENT': '4. 移动', '5. CATCH ENEMIES': '5. 吃掉对手', '6. PIGGYBACK': '6. 叠子', '7. WINNING': '7. 获胜', '8. TIPS': '8. 提示',
  'GET ANOTHER TURN, EVEN WHEN\nYOU CATCH WITH A YUT OR MO.': '即使用擲木或莫吃子，\n也能获得额外回合。',
  'TEAM\nROCKET': '火箭\n队', 'TEAM\nUFO': '飞碟\n队', 'YUT NORI!': '四维游戏！', 'YUT NORI': '四维游戏', 'ROOM ID': '房间编号', 'HOST': '房主', 'RULEBOOK': '规则书', 'SOUND': '声音', 'INVITE FRIENDS': '邀请朋友', 'SETTINGS': '设置',
  'SCAN THE QR CODE TO JOIN\nTHIS ROOM, OR COPY THE\nLINK AND SHARE WITH\nYOUR FRIENDS': '扫描二维码加入此房间，\n或复制链接并分享给\n你的朋友。',
  'COPY LINK': '复制链接', 'copied!': '已复制！', 'START GAME!': '开始游戏！', 'WAITING FOR CREW...': '正在等待队员……', 'HOST WILL START': '等待房主开始', 'SHARE THIS LOBBY': '分享此大厅', "I'M READY!": '我准备好了！', 'PLAYERS': '玩家', 'SELECT LANGUAGE': '选择语言', 'X CLOSE': 'X 关闭', 'TAKE SEAT': '入座',
  'ADD AI - EZ': '添加 AI - 简单', 'ADD AI': '添加 AI', 'ASSIGN HOST': '指定房主', 'KICK': '移出', 'SET SPECTATOR': '设为观战者', 'EDIT': '编辑', 'CLICK TO SIT': '点击入座', 'OPEN SEAT': '空位', 'Join the': '加入', 'rockets': '火箭队', 'ufos': '飞碟队', 'as': '作为', 'name...': '名字……', 'LEGGO!': '出发！', 'NAH': '取消',
  'VIEWER': '观战者', 'AI playing': 'AI 正在行动', 'ROCKETS': '火箭队', 'UFOS': '飞碟队', 'THROW': '投掷', 'BONUS': '奖励', 'PREGAME': '赛前', 'RULES': '规则', 'CHAT': '聊天', 'LOGS': '记录', 'MOVES': '移动', 'Who goes first?': '谁先开始？',
  'One player from each team throws\nthe yoot. The team with a higher\nnumber goes first.': '每队各一位玩家投掷擲木。\n点数更高的队伍\n先开始。',
  'RESET GAME': '重置游戏', 'QUIT': '退出', 'BACK': '返回', 'EDIT GUESTS': '编辑玩家', 'SET RETURNED': '设为返回', 'SET AWAY': '设为离开', 'PAUSE GAME': '暂停游戏', 'UNPAUSE': '继续游戏', 'SET GAME RULES': '设置游戏规则', 'VIEW GUESTS': '查看玩家', 'VIEW GAME RULES': '查看游戏规则', 'MENU': '菜单', 'ACTIONS': '操作', 'HOST     YOU': '房主     你', 'SET TEAM TO ROCKETS': '设为火箭队', 'SET TEAM TO UFOS': '设为飞碟队',
  'ALL PROGRESS WILL BE ERASED.\nARE YOU SURE?': '所有进度将被清除。\n确定吗？', 'YES': '是', 'NO': '否', 'YOU': '你', 'say something...': '说点什么……',
  'TIMES\nUP!': '时间\n到！', 'PAUSED': '已暂停', 'YOOT': '擲木', 'BACKDO': '后道', 'NO TOKEN': '没有棋子', 'BONUS THROW': '额外投掷', 'ROCKETS WIN!': '火箭队获胜！', 'UFOS WIN!': '飞碟队获胜！', 'TIE!': '平局！', 'GO AGAIN!': '再来一次！', 'OUT': '出界', 'THROWN OUT...': '已出界……', 'ALL CLEAR!': '全部清除！', 'YOUR TURN!': '轮到你了！', 'Welcome\n     Back!': '欢迎\n     回来！', '     ALIEN\nINVASION!': '     外星人\n入侵！', 'piggyback!': '叠子！', 'GAME\nSTART!': '游戏\n开始！', 'Disconnected from\nserver. Reconnecting': '已与服务器断开连接。\n正在重连', 'refresh': '刷新',
  'MISSION ABORT!': '任务中止！', 'LOST IN SPACE!': '迷失太空！', 'ALIEN INVASION!': '外星人入侵！', 'PLAY AGAIN': '再玩一次', 'SHARE LINK': '分享链接', 'DISCORD': 'DISCORD', 'K-BOARD GAME': '韩国棋盘游戏'
}

function addSpanishTranslations(value) {
  if (!value || typeof value !== 'object') return value
  if (typeof value.english === 'string' && !value.spanish) {
    value.spanish = spanishByEnglish[value.english] ?? value.english
  }
  for (const child of Object.values(value)) addSpanishTranslations(child)
  return value
}

function addChineseTranslations(value) {
  if (!value || typeof value !== 'object') return value
  if (typeof value.english === 'string' && !value.chinese) {
    value.chinese = chineseByEnglish[value.english] ?? value.english
  }
  for (const child of Object.values(value)) addChineseTranslations(child)
  return value
}

export default addChineseTranslations(addSpanishTranslations(translations))